import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// types
import { ReservationCardMobileBreakpoint, ReservationCardStyle } from './types'

// styles
import { NotinoLabelRegular400, truncate } from '../../styles/helpers'
import { BREAKPOINTS } from '../../styles/constants'

export const ReservationCardContainer = styled.a<{ $breakpoint: ReservationCardMobileBreakpoint; $isSkeleton?: boolean; $cardStyle: ReservationCardStyle }>`
	${({ $breakpoint, $isSkeleton }) => css`
		width: 100%;
		overflow: hidden;
		text-decoration: none;
		cursor: ${$isSkeleton ? 'default' : 'pointer'};
		height: 100%;
		padding: 1rem;
		display: flex;
		flex-direction: column;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			padding: 1.25rem;
		}
	`}

	${({ $cardStyle, $isSkeleton }) => {
		switch ($cardStyle) {
			case 'past':
				return css`
					background: ${$isSkeleton ? theme.color.background.tertiary : theme.color.background.secondary};
				`
			case 'future':
			default:
				return css`
					border: 1px solid ${theme.color.border.divider};
				`
		}
	}}
`

export const ReservationStatusContainer = styled.div<{ $breakpoint: ReservationCardMobileBreakpoint }>`
	${({ $breakpoint }) => css`
		margin-bottom: 0.5rem;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			margin-bottom: 0.625rem;
		}
	`}
`

export const SalonName = styled.div<{ $breakpoint: ReservationCardMobileBreakpoint }>`
	${({ $breakpoint }) => css`
		font-size: 1.125rem;
		line-height: 1.5rem;
		min-height: 1.5rem;
		font-weight: 500;
		color: ${theme.color.text.primary};
		display: flex;
		align-items: center;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			font-size: 1.25rem;
			line-height: 2rem;
			min-height: 2rem;
		}
	`}
`

export const DateTime = styled.div<{ $breakpoint: ReservationCardMobileBreakpoint }>`
	${({ $breakpoint }) => css`
		font-size: 0.875rem;
		line-height: 1.25rem;
		min-height: 1.25rem;
		font-weight: 500;
		color: ${theme.color.text.tertiary};
		margin-bottom: 0.5rem;
		display: flex;
		align-items: center;
		text-transform: capitalize;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			font-size: 1rem;
			line-height: 1.5rem;
			min-height: 1.5rem;
			margin-bottom: 0.625rem;
		}
	`}
`

export const ServiceAndEmployeeContainer = styled.div`
	display: flex;
	gap: 0.625rem;
	margin-top: auto;
`

export const ServiceName = styled.div`
	${truncate};
	${NotinoLabelRegular400};
	flex: 1 1;
	max-width: fit-content;
	min-width: 1.25rem;
	color: ${theme.color.text.primary};
`

export const EmployeeContainer = styled.div`
	display: flex;
	gap: 0.625rem;
	overflow: hidden;
	flex: 1 1 auto;
	max-width: fit-content;

	img {
		width: 1.25rem;
		height: 1.25rem;
		display: block;
		object-fit: cover;
		flex-shrink: 0;
		border-radius: 50%;
		overflow: hidden;
	}
`

export const EmployeeName = styled.div`
	${truncate};
	${NotinoLabelRegular400};
	flex: 1 1 auto;
	color: ${theme.color.text.primary};
`

export const EmployeeDivider = styled.div`
	height: 1.25rem;
	width: 1px;
	background: ${theme.color.border.divider};
`
